






































import {
  defineComponent,
  del,
  PropType,
  ref,
  set,
  toRefs,
  watch
} from '@nuxtjs/composition-api'

import CMapLocationInput from '~/components/shared/configurable/location/CMapLocationInput.vue'
import { useLabel } from '~/compositions/form-component/label'
import { useDynamicFormField } from '~/compositions/dynamic-form/field'
import { TranslateResult } from 'vue-i18n'
import { FormFieldErrors, SchemaField } from '~/models/shared/types'

export default defineComponent({
  model: {
    prop: 'fieldValues',
    event: 'change'
  },
  components: { CMapLocationInput },
  props: {
    fields: {
      type: Array as PropType<SchemaField[]>,
      default() {
        return []
      }
    },
    cols: {
      type: Object,
      default() {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    fieldValues: {
      type: Object as PropType<Record<string, any>>,
      default() {
        return {}
      }
    },
    fieldErrors: {
      type: Object as PropType<FormFieldErrors>,
      default() {
        return {}
      }
    },
    hideFields: {
      type: Array as PropType<SchemaField['name'][]>,
      default() {
        return []
      }
    },
    labels: {
      type: Array as PropType<
        { label: string | TranslateResult; field: string }[]
      >,
      default: () => []
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    const {
      cols,
      fieldValues,
      fieldErrors,
      hideFields,
      labels,
      fullWidth
    } = toRefs(props)

    const internalFieldValues = ref<any>({})
    const internalFieldErrors = ref<any>({})

    const { getLabelClass } = useLabel()

    const { getFieldComponent, getFieldLabel } = useDynamicFormField()

    const assignFieldLabel = (name: string, context?: string) => {
      if (labels.value.length > 0) {
        const label = labels.value.find(l => l.field === name)
        if (label) return label.label
      }
      return getFieldLabel(name, context)
    }

    watch(
      fieldValues,
      newFieldValues => (internalFieldValues.value = newFieldValues),
      { immediate: true }
    )
    watch(fieldErrors, newErrors => (internalFieldErrors.value = newErrors), {
      immediate: true
    })

    function getFieldCols(name: string) {
      return cols.value[name] ?? { cols: 12, md: fullWidth.value ? 12 : 6 }
    }

    function handleFieldChange(
      fieldsChanges: {
        name: string
        value: any
      }[]
    ) {
      for (const { name, value } of fieldsChanges) {
        set(internalFieldValues.value, name, value)
        del(internalFieldErrors.value, name)
      }

      emit('change', internalFieldValues.value)
    }

    function shouldShowField(name: SchemaField['name']) {
      return !hideFields.value.includes(name)
    }

    return {
      getFieldCols,
      getFieldComponent,
      internalFieldValues,
      internalFieldErrors,
      handleFieldChange,
      assignFieldLabel,
      getLabelClass,
      shouldShowField
    }
  }
})
